MarketReportsApp.Models.ReportStatus = Backbone.Model.extend({urlRoot: '/api/queue/notification/report'});
MarketReportsApp.Models.PostProcessReportStatus = Backbone.Model.extend({urlRoot: '/api/queue/notification/postProcessReport'});